export enum PURCHASE_ORDER_TYPE {
    OPEX = 'OPEX',
    CAPEX = 'CAPEX',
}
